export const TOP = 'TOP';
export const LEFT = 'LEFT';
export const RIGHT = 'RIGHT';
export const BOTTOM = 'BOTTOM';

export const all = [TOP, LEFT, RIGHT, BOTTOM];
